'use client';

import { useRouter } from 'next/navigation';
import Back2424 from '@svg/common/back_24_24.svg';
import Home2424 from '@svg/main/sideMenu/home_24_24.svg';

export default function PoiDetailTopBar({ name, hasHomeButton }: { name: string | null; hasHomeButton: boolean }) {
  const router = useRouter();

  return (
    <div className='fixed z-10 items-center w-full bg-white p-16pxr max-w-480pxr flex flex-row justify-between'>
      <div className='flex flex-row gap-8pxr items-center'>
        <button onClick={() => router.back()}>
          <Back2424 />
        </button>
        {name ? (
          <h4 className='line-clamp-1 text-custom-black heading-18-b h-24pxr'>{name}</h4>
        ) : (
          <div className='h-24pxr w-100pxr skeleton-item rounded-2pxr' />
        )}
      </div>
      {hasHomeButton && (
        <button onClick={() => router.push('/')}>
          <Home2424 />
        </button>
      )}
    </div>
  );
}
